import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoint } from "../../urls";
import { refreshToken } from "./pdfEditorTokenSlice";

// Load initial state from localStorage
const savedDocument = localStorage.getItem("uploadedDocument");

export const uploadDocument = createAsyncThunk(
  "uploadDocument/upload",
  async ({ token, file, files, fileName, bulkEsign, stampId }, { dispatch, rejectWithValue }) => {
    const performUpload = async (authToken) => {
      const formData = new FormData();
      console.log(files.length)
      if (files && files.length > 0) {
        // ✅ Multiple files case
        files.forEach((f) => {
          formData.append("document", f?.file); // key name: "documents" (adjust if API expects different)
        });
      } else if (file) {
        // ✅ Single file case (backward-compatible)
        formData.append("document", file?.file, fileName);
      }
      formData.append("source", "website");
      formData.append("bulk_esign", bulkEsign);

      const response = await axios.post(
        `${apiEndpoint.pdfBaseUri}/editor/upload_document/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const documentData = { ...response.data, fullView: true, stamp_id: stampId, };
      console.log(documentData)
      localStorage.setItem("uploadedDocument", JSON.stringify(documentData));
      return documentData;
    };

    try {
      return await performUpload(token);
    } catch (error) {
      const status = error?.response?.status;

      if (status === 401) {
        console.log("401 detected, attempting to refresh token...");
        const refreshResult = await dispatch(refreshToken());
        console.log(refreshResult)
        if (refreshToken.fulfilled.match(refreshResult)) {
          const newToken = refreshResult.payload?.access;
          if (!newToken) return rejectWithValue("Token refresh failed.");

          try {
            return await performUpload(newToken); // retry with new token
          } catch (retryError) {
            const msg = retryError?.response?.data?.message || "Retry upload failed.";
            return rejectWithValue(msg);
          }
        } else {
          return rejectWithValue("Token refresh failed.");
        }
      }

      const msg = error?.response?.data?.message || "Upload failed.";
      return rejectWithValue(msg);
    }
  }
);


const initialState = {
  uploadedDocument: savedDocument ? JSON.parse(savedDocument) : null,
  isLoading: false,
  error: null,
};

const uploadDocumentSlice = createSlice({
  name: "uploadDocument",
  initialState,
  reducers: {
    setUploadedDocument: (state, action) => {
      state.uploadedDocument = action.payload;
      localStorage.setItem("uploadedDocument", JSON.stringify(action.payload)); // Keep storage updated
    },
    clearUploadedDocument: (state) => {
      state.uploadedDocument = null;
      localStorage.removeItem("uploadedDocument");
      window.location.replace(`${process.env.PUBLIC_URL}/esign/documents?activeTab=1`);
    },
    clearUploadedDocumentFromTab: (state) => {
      state.uploadedDocument = null;
      localStorage.removeItem("uploadedDocument");
    },
    updateDocumentName: (state, action) => {
      if (state.uploadedDocument?.data?.document_id === action.payload.document_id) {
        state.uploadedDocument.data.document_name = action.payload.document_name;
        localStorage.setItem("uploadedDocument", JSON.stringify(state.uploadedDocument));
      }
    },
    toggleFullView: (state) => {
      if (state.uploadedDocument) {
        // state.uploadedDocument.fullView = !state.uploadedDocument.fullView;
        state.uploadedDocument.fullView = true;
        localStorage.setItem("uploadedDocument", JSON.stringify(state.uploadedDocument));
      }
    },
    updateDocumentTemplate: (state, action) => {
      if (state.uploadedDocument?.data) {
        state.uploadedDocument.data.document_template = action.payload;
        localStorage.setItem("uploadedDocument", JSON.stringify(state.uploadedDocument));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadDocument.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(uploadDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.uploadedDocument = action.payload;
        localStorage.setItem("uploadedDocument", JSON.stringify(action.payload));
      })
      .addCase(uploadDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setUploadedDocument, clearUploadedDocument, clearUploadedDocumentFromTab, updateDocumentName, toggleFullView, updateDocumentTemplate } = uploadDocumentSlice.actions;
export default uploadDocumentSlice.reducer;
